import { BREAKPOINTS } from '../config';

import { lenis } from '../layout/lenis';

export function toggleAttrByMedia(el, query, attr) {
  const mq = window.matchMedia(`(max-width: ${query}px)`);

  const handler = e => {
    el.toggleAttribute(attr, e.matches);
  };

  handler(mq);
  mq.addEventListener('change', handler);
}

export function initScrollSplide(thinkingSection, splideInstance) {
  if (!thinkingSection || !splideInstance || !lenis) return;

  const slidesCount = splideInstance.Components.Slides.getLength();
  let lastIndex = -1;

  lenis.on('scroll', ({ scroll }) => {
    if (window.innerWidth <= BREAKPOINTS.mqTouch) return;

    const rect = thinkingSection.getBoundingClientRect();
    const sectionTop = rect.top + scroll;
    const sectionHeight = thinkingSection.offsetHeight;
    const viewportHeight = window.innerHeight;

    const start = sectionTop;
    const end = sectionTop + sectionHeight - viewportHeight;

    if (scroll < start || scroll > end) return;

    const progress = scroll - start;
    const slideStep = (sectionHeight - viewportHeight) / slidesCount;

    const index = Math.min(slidesCount - 1, Math.floor(progress / slideStep));

    if (index !== lastIndex) {
      splideInstance.go(index);
      lastIndex = index;
    }
  });
}

export function initSplideSync(sectionEl, splideInstance) {
  if (!sectionEl || !splideInstance) return;

  const images = sectionEl.querySelectorAll('.industries__images');
  const logos = sectionEl.querySelectorAll('.industries__logos');

  if (!images.length || !logos.length) return;

  function clearActive() {
    [...images, ...logos].forEach(el => {
      el.classList.remove('is-active', 'is-visible');
    });
  }

  function activate(index) {
    const image = images[index];
    const logo = logos[index];

    if (!image || !logo) return;

    requestAnimationFrame(() => {
      image.classList.add('is-active');
      logo.classList.add('is-active');

      requestAnimationFrame(() => {
        image.classList.add('is-visible');
        logo.classList.add('is-visible');
      });
    });
  }

  function syncBySlide(slide) {
    clearActive();
    activate(slide.index);
  }

  const slide = splideInstance.Components.Slides.getAt(splideInstance.index);
  if (slide) syncBySlide(slide);

  splideInstance.on('active', slide => {
    syncBySlide(slide);
  });
}
